'use strict'
import {
  serialize
} from './index'
import AppError from './errors'
import ERRORS from '../constants/errors'
import router from '../router'
import PAGES from '../constants/page'
import 'whatwg-fetch'
import toast from '../components/toast'
//这个档案是做什么的？
//这个档案是用来处理网络请求的，这里面有一个request方法，这个方法是用来发送网络请求的，这个方法会返回一个promise对象，这个promise对象会返回一个json对象，这个json对象是服务器返回的数据，这个json对象有一个success属性，如果success属性为true，那么就是请求成功，如果success属性为false，那么就是请求失败，这个时候就会抛出一个AppError的错误，这个错误会在catch里面捕获到，然后在catch里面处理错误，比如说提示用户错误信息，或者跳转到错误页面。
//这个档案里面还有一个verbs对象，这个对象里面有两个方法，一个是GET方法，一个是POST方法，这两个方法都是用来发送网络请求的，只不过一个是GET请求，一个是POST请求，这两个方法都是用fetch方法来发送网络请求的，fetch方法是一个原生的方法，这个方法是用来发送网络请求的，这个方法会返回一个promise对象，这个promise对象会返回一个response对象，这个response对象是服务器返回的数据，这个response对象有一个ok属性，如果ok属性为true，那么就是请求成功，如果ok属性为false，那么就是请求失败，这个时候就会抛出一个AppError的错误，这个错误会在catch里面捕获到，然后在catch里面处理错误，比如说提示用户错误信息，或者跳转到错误页面。
//这个档案里面还有一个serialize方法，这个方法是用来把一个对象转换成一个字符串的，这个�

export const verbs = {
  GET (url, params) {
    return fetch(params ? `${url}?${params}` : url, {
      credentials: 'same-origin'
    })
  },
  POST (url, params) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params
    })
  }
}

export const request = (url, method = 'GET', params = {}) => {
  console.log(url)
  return verbs[method](url, serialize(params))
    .then(res => {
      if (res.ok) {
        return res
      } else {
        throw new AppError(ERRORS.NETWORK_ERROR)
      }
    })
    .then((res) => res.json())
    .then((res) => {
      if (!res.success && (res.msg === '未登录' || res.msg === '用户已登出')) {
        console.log(router.currentRoute)

        toast.hide()
        router.replace({
          name: PAGES.LOGIN,
          query: {url: router.history.current.path}
        })
         throw new AppError(ERRORS.SESSION_EXPIRE)
      } else {
        return res
      }
    })
}



// WEBPACK FOOTER //
// ./src/utils/request.js